import React from 'react';

const PoppyIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <path
      d='M22.5 16a3.5 3.5 0 0 0 3.5-3.5A6.5 6.5 0 0 0 19.5 6 3.5 3.5 0 0 0 16 9.5 3.5 3.5 0 0 0 12.5 6 6.5 6.5 0 0 0 6 12.5 3.5 3.5 0 0 0 9.5 16 3.5 3.5 0 0 0 6 19.5a6.5 6.5 0 0 0 6.5 6.5 3.5 3.5 0 0 0 3.5-3.5 3.5 3.5 0 0 0 3.5 3.5 6.5 6.5 0 0 0 6.5-6.5 3.5 3.5 0 0 0-3.5-3.5M16 20a4 4 0 1 1 0-8 4 4 0 0 1 0 8m2.5-4a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z'
      fill='currentColor'
      fillRule='nonzero'
    />
  </svg>
);

export default PoppyIcon;
